module.exports = __webpack_public_path__ + "img/Maschinist.639cd770.svg";